export const youtubeLink = "https://www.youtube.com/embed/Ipp9zGOnmn4";
// Note: This link is required to be hardcoded in the Demo Button Click metric in launch darkly. Sync updates there
export const CalendlyLink = "https://calendly.com/elimernit/30min";
export const docsLink = "https://docs.beam.cloud";
export const dashboardLink = "https://platform.beam.cloud";
export const slackLink =
  "https://join.slack.com/t/beam-cloud/shared_invite/zt-3enuvj3r7-OeAzVPYvyqQHy9avNrLL0w";
export const statusLink = "https://status.beam.cloud";
export const privacyLink = "https://docs.beam.cloud/v2/security/privacy-policy";
export const termsLink = "https://docs.beam.cloud/v2/security/terms-and-conditions";
export const jobsLink = "https://www.ycombinator.com/companies/beam/jobs";
export const githubLink = "https://github.com/beam-cloud/beta9/";
export const linkedinLink = "https://www.linkedin.com/company/beamcloud/";
export const xLink = "https://x.com/beam_cloud";
export const changelogLink = "https://docs.beam.cloud/v2/releases/";
export const demoLink = "https://form.typeform.com/to/XFaCSAub";
export const sandboxDemoLink = "https://platform.beam.cloud/sandbox-demo";
